const STABLE_FRAMES = 3;
const MAX_WAIT_MS = 1000;

export function watchScrollSettle(element: HTMLElement, onSettled: () => void): () => void {
  const startedAt = performance.now();
  let last = element.getBoundingClientRect();
  let stableFrames = 0;

  let frame = requestAnimationFrame(function check(now) {
    const rect = element.getBoundingClientRect();
    stableFrames = rect.top === last.top && rect.left === last.left ? stableFrames + 1 : 0;
    last = rect;
    if (stableFrames >= STABLE_FRAMES || now - startedAt >= MAX_WAIT_MS) {
      onSettled();
      return;
    }
    frame = requestAnimationFrame(check);
  });

  return () => cancelAnimationFrame(frame);
}
